import { render, staticRenderFns } from "./BlockFileUpload.vue?vue&type=template&id=557ba6b6&scoped=true"
import script from "./BlockFileUpload.vue?vue&type=script&lang=js"
export * from "./BlockFileUpload.vue?vue&type=script&lang=js"
import style0 from "./BlockFileUpload.vue?vue&type=style&index=0&id=557ba6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ba6b6",
  null
  
)

export default component.exports